<script setup>

import {computed, defineEmits, defineProps} from 'vue'
import {useStore} from "vuex";

const store = useStore()

const emit = defineEmits(['callback'])

const props = defineProps({
  folderId: { type: String, default: '' },
  emoji: { type: String, default: '' },
  reacts: { type: Array },
  total: { type: Number, default: 0 },
})

const tooltipsText = computed(() => {
  const reacts = props.reacts || []
  const count = reacts.length

  if (count === 0) return ''
  if (count === 1) return i18n.global.t('projects.one_react', {user: reacts[0]?.user_name})

  if (count <= 3) {
    const names = reacts.slice(0, count).map(r => r?.user_name).join(' and ')
    return i18n.global.t('projects.two_react', {user: names})
  }

  const names = reacts.slice(0, 3).map(r => r?.user_name).join(', ')
  return i18n.global.t('projects.more_react', {user: names, count: count - 3})
})

function makeOrUpdateReact() {
  store.dispatch('projects/updateReactForProject', {id: props.folderId, comment: props.emoji } )
      .then(res => {
        emit('callback')
      })
      .catch(() => {})
      .finally(() => {})
}


</script>

<template>
  <div
      @click.prevent="makeOrUpdateReact"
       :title="tooltipsText"
      class="card d-flex flex-row align-items-center shadow rounded-sm w-120px p-2 text-gray-400 text-hover-primary fw-bold">
    {{ total }}
    <i v-if="emoji" class="fa cursor-pointer  ms-2 text-primary" v-html="emoji" style="font-size: 1.2rem"></i>
    <i v-else class="fa fa-thumbs-up cursor-pointer fw-bold fs-2 ms-2 text-primary" style="font-size: 1.2rem"></i>
  </div>
</template>

<style>



</style>